var exports = {
  "kL": "xa15a2ab7--39f4f7--container",
  "Sl": "xa15a2ab7--39f4f7--image",
  "p_": "xa15a2ab7--39f4f7--list",
  "AS": "xa15a2ab7--39f4f7--item",
  "Uo": "xa15a2ab7--39f4f7--buttons",
};

module.exports = exports;
